export default "__VITE_ASSET__XAOnyt44__"